export const commentsData = [
    {
      name: "User 1",
      text: "Comment 1",
      replies: [
        {
          name: "User 2",
          text: "Reply 1 to Comment 1",
        },
        {
          name: "User 3",
          text: "Reply 2 to Comment 1",
        },
      ],
    },
    {
      name: "User 4",
      text: "Comment 2",
      replies: [
        {
          name: "User 5",
          text: "Reply 1 to Comment 2",
        },
      ],
    },
    {
      name: "User 6",
      text: "Comment 3",
      replies: [],
    },
    {
      name: "User 7",
      text: "Comment 4",
      replies: [
        {
          name: "User 8",
          text: "Reply 1 to Comment 4",
        },
        {
          name: "User 9",
          text: "Reply 2 to Comment 4",
        },
        {
          name: "User 10",
          text: "Reply 3 to Comment 4",
        },
      ],
    },
    {
      name: "User 11",
      text: "Comment 5",
      replies: [],
    },
    {
      name: "User 12",
      text: "Comment 6",
      replies: [
        {
          name: "User 13",
          text: "Reply 1 to Comment 6",
        },
        {
          name: "User 14",
          text: "Reply 2 to Comment 6",
        },
      ],
    },
    {
      name: "User 15",
      text: "Comment 7",
      replies: [],
    },
    {
      name: "User 16",
      text: "Comment 8",
      replies: [],
    },
    {
      name: "User 17",
      text: "Comment 9",
      replies: [],
    },
    {
      name: "User 18",
      text: "Comment 10",
      replies: [],
    },
    {
      name: "User 19",
      text: "Comment 11",
      replies: [],
    },
    {
      name: "User 20",
      text: "Comment 12",
      replies: [
        {
          name: "User 21",
          text: "Reply 1 to Comment 12",
        },
      ],
    },
    {
      name: "User 22",
      text: "Comment 13",
      replies: [ {
        name: "User 23",
        text: "Comment 14",
        replies: [
          {
            name: "User 24",
            text: "Reply 1 to Comment 14",
          },
        ],
      },
      {
        name: "User 25",
        text: "Comment 15",
        replies: [{
          name: "User 26",
          text: "Comment 16",
          replies: [  {
            name: "User 27",
            text: "Comment 17",
            replies: [  {
              name: "User 28",
              text: "Comment 18",
              replies: [ {
                name: "User 29",
                text: "Comment 19",
                replies: [ {
                  name: "User 30",
                  text: "Comment 20",
                  replies: [],
                },],
              },],
            },
           ],
          },
        
         ],
        },
      ],
      },
     ],
    },
    
  ];
  